import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';

type THIS_API = ApiDefinition['/ai/agents/{agentId}/run-agent']['POST'];
type Input = THIS_API['params'] & THIS_API['body'];
type Output = THIS_API['response'];

const runAgent = async ({ agentId, inputs, metadata }: Input): Promise<Output> => {
  const response = await noodleApiClient.post(`/ai/agents/${agentId}/run-agent`, { inputs, metadata });
  return response.data;
};

export default runAgent;
